export const mutations = {
  SET_USER_INFO: (state, info) => {
    state.userInfo = info;
  },
  SIGNIN_OUT (state) {
    state.userInfo = {};
  },
  SET_NAV_LIST: (state, list) => {
    state.navList = list;
  },
  RESET_NAV_LIST (state) {
    state.navList = null;
  },
  SET_CLICK_TOKEN (state, clickToken) {
    state.clickToken = clickToken;
  },
  SET_TENANT_PARAMS: (state, info) => {
    state.tenantParams = info;
  }
};
